import { SidebarFullscreenContainer } from '@efdigital/ll-admin-v2/components/sidebar/sidebar-fullscreen-container.gts';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const ProgramsProgramCohortContentTemplate: TemplateOnlyComponent = <template>
  <SidebarFullscreenContainer>
    {{outlet}}
  </SidebarFullscreenContainer>
</template>;

export default ProgramsProgramCohortContentTemplate;
